<mat-form-field appearance="outline" class="w-100">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    #nativeElement
    [formControl]="control"
    [compareWith]="provider.compareWith"
    (selectionChange)="onSelectValueChanged($event)"
    (blur)="onBlurEvent()"
    [errorStateMatcher]="matcher"
  >
    <mat-option *ngFor="let option of provider.options" [value]="option">
      {{ provider.description(option) }}
    </mat-option>
  </mat-select>
  <mat-icon *ngIf="error()" matSuffix class="mat-error">error</mat-icon>
  <mat-hint>{{ hint }}</mat-hint>
  <mat-error *ngIf="error()">{{ error() }}</mat-error>
</mat-form-field>
